// extracted by mini-css-extract-plugin
module.exports = {"bankCard":"index-module_bankCard_3JYNZ","icon":"index-module_icon_WpLep","name":"index-module_name_2DY9G","arrow":"index-module_arrow_1-X0n"};